export default `<svg width="364" height="364" viewBox="0 0 364 364" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1954_614)">
<path d="M181.68 364C282.377 364 364 282.522 364 182C364 81.4778 282.377 0 181.68 0C86.1515 0 7.7896 73.3533 0 166.697H240.983V197.303H0C7.7896 290.647 86.1515 364 181.68 364Z" fill="black"/>
</g>
<defs>
<clipPath id="clip0_1954_614">
<rect width="364" height="364" fill="white"/>
</clipPath>
</defs>
</svg>
`;
